// extracted by mini-css-extract-plugin
export var chevron = "_p0-1";
export var clickable = "_p0-0";
export var ruleRow = "_p0-2";